import React from 'react'

import './styles.css'

interface Props {
  onComplete?: () => void
  isVisible?: boolean
  color?: string
}

const Countdown: React.FC<Props> = ({ onComplete, isVisible = false, color = 'deep-green' }) => {
  const [count, setCount] = React.useState(3)
  const [isAnimating, setIsAnimating] = React.useState(false)

  React.useEffect(() => {
    if (!isVisible) return

    const timer = setInterval(() => {
      setIsAnimating(true)

      setTimeout(() => {
        setCount((prev) => {
          if (prev <= 1) {
            clearInterval(timer)
            setTimeout(() => {
              onComplete?.()
            }, 600)
            return 0
          }
          return prev - 1
        })
        setIsAnimating(false)
      }, 100)
    }, 800)

    return () => clearInterval(timer)
  }, [isVisible, onComplete])

  if (!isVisible) return null

  return (
    <div className={`countdown-number text-${color} ${isAnimating ? 'glitch' : ''}`}>
      {count}
    </div>
  )
}

export default Countdown
